'use client';

import { ExternalLink } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Alert } from '@//components/Alert';
import { Button } from '@//components/Button';
import { useLegacyTrackAuctionClick } from '@//data/tracking/useLegacyTrackAuctionClick';

interface AuctionButtonProps {
  vehicle: ElasticVehicle;
}

export const AuctionButton: React.FC<AuctionButtonProps> = ({ vehicle }) => {
  const t = useTranslations('pages.item.informationSection');
  const { trackLegacyAuctionClick } = useLegacyTrackAuctionClick();

  const handleAuctionClick = () => {
    trackLegacyAuctionClick(vehicle);
  };

  if (!vehicle.isAuctionItem) {
    return null;
  }

  if (!vehicle.externalUrl) {
    return (
      <Alert id="alert-no-externallink" variant="critical">
        {t('contact.auctionButton.missingLinkAlert')}
      </Alert>
    );
  }

  return (
    <Button
      href={vehicle.externalUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      onClick={handleAuctionClick}
      title={t('contact.auctionButton.title')}
      sizeLtMd="lg"
      sizeMd="xl"
      fullWidth
      variant="cta"
    >
      {t('contact.auctionButton.label')}
      <ExternalLink aria-hidden="true" />
    </Button>
  );
};
